(function(angular, module) {var synchronizerFactory,
  bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; },
  extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
  hasProp = {}.hasOwnProperty;

synchronizerFactory = function($q, $timeout, Debouncer) {
  'ngInject';
  var Synchronizer;
  Synchronizer = (function(superClass) {
    extend(Synchronizer, superClass);

    function Synchronizer(delay) {
      this.sync = bind(this.sync, this);
      this.wait = bind(this.wait, this);
      this.promises = [];
      Synchronizer.__super__.constructor.call(this, this.wait, delay);
    }

    Synchronizer.prototype.wait = function() {
      return $q.all(this.promises).then((function(_this) {
        return function() {
          return _this.promises = [];
        };
      })(this));
    };

    Synchronizer.prototype.sync = function(promise) {
      var deferred;
      deferred = $q.defer();
      this.promises.push(promise);
      this.call().then(function() {
        return deferred.resolve(promise);
      });
      return deferred.promise;
    };

    return Synchronizer;

  })(Debouncer);
  return Synchronizer;
};

module.factory('Synchronizer', synchronizerFactory);
})(angular, angular.module("dyb.util"));